import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Primera pantalla permitida según roles del access token. */
export const HOME_CANDIDATES: ReadonlyArray<readonly [string, string]> = [
  ['FORECAST_SALES_OPERATIONS_READ', '/forecasts/sales-operations'],
  ['FORECAST_CASH_FLOW_READ', '/forecasts/cash-flow'],
  ['FORECAST_PIPELINE_READ', '/forecast-pipeline'],
  ['SALE_LIST', '/sales'],
  ['CUSTOMER_LIST', '/customers'],
  ['COMPANY_READ', '/company']
];

export function firstAllowedHomeUrl(auth: AuthService): string {
  for (const [permission, url] of HOME_CANDIDATES) {
    if (auth.hasRole(permission)) {
      return url;
    }
  }
  return '/profile';
}

export const homeRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const auth = inject(AuthService);
  return router.parseUrl(firstAllowedHomeUrl(auth));
};
